import { useQuery, useMutation } from "@tanstack/react-query";
import { instanceWithToken } from "../../axios.config";

export const useAddressList = () => {
  return useQuery({
    queryKey: ["addressList"],
    queryFn: async () => {
      const {
        data: { data },
      } = await instanceWithToken.get("addresses");
      return data;
    },
  });
};

export const useAddAddress = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("addresses", body);
      return data;
    },
  });
};
export const useDeleteAddress = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.delete(`addresses/${body}`);
      return data;
    },
  });
};
export const useUpdateAddress = (id) => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.put(`addresses/${id}`, body);
      return data;
    },
  });
};
